import QuestionsAnswersQuery from '../queries/user-generated-content/questions.graphql';
import { useQuery } from './useQuery';

const useQuestionsAnswers = ({
  itemId, startindex = 1, pagesize = 10, options, variables = {}
}) => {
  let opts = options;
  if (typeof opts === 'undefined') {
    opts = {
      variables: {
        itemId,
        startindex,
        pagesize,
        ...variables
      }
    };
  }
  return useQuery(QuestionsAnswersQuery, opts);
};

export default useQuestionsAnswers;
